<template>
  <div class="sample-card-container">
    <div class="sample-card-list">
      <div
        :id="'sample_'+key" class="sample-line column-xs row-md" v-for="(sample, key) in getSample" :key="'sample_'+key"
      >
        <div class="form-field line-align-top">
          <span>{{key+1}}</span>
        </div>
        <div class="form-field">
          <label>{{$_('model')}}</label>
          <Input
            :type="'text'"
            class="input-mod"
            :val="getSample[key].tmod"
            @typing="vSetStoreSample('tmod', key, $event)"
          />
        </div>
        <div class="form-field">
          <label>{{$_('packaging')}}</label>
          <Select
            :placeholder="$_('your_choice')"
            :itemoption="['TOPT', 'TLIB_OPT']"
            :data="line_data[key]['packaging']"
            :resetselect="reset"
            @select-change="vSetStoreSample('topt', key, $event)"
          />
        </div>
        <div class="form-field">
          <label>{{$_('size')}}</label>
          <Select
            :placeholder="$_('your_choice')"
            :itemoption="['TTAIL', 'TLIB_TAIL']"
            :data="line_data[key].size"
            :resetselect="reset"
            @select-change="vSetStoreSample('ttail', key, $event)"
          />
        </div>
        <div class="form-field">
          <label>{{$_('color')}}</label>
          <Select
            :placeholder="$_('your_choice')"
            :data="line_data[key].color"
            :search="true"
            :resetselect="reset"
            @select-change="vSetStoreSample('tcol', key, $event)"
          />
        </div>
        <div class="form-field">
          <label>{{$_('quantity')}}</label>
          <Input
            class="box-qte" 
            :type="'number'"  
            @typing="vSetStoreSample('tqte', key, $event)"
            :val="getSample[key].tqte"
          />
        </div>
        <div class="form-field line-align-top">
          <span class="btn-control-quantity" 
          @click="vSetStoreSample('tqte', key, sample.tqte+1)">+</span>
        </div>
        <div class="form-field line-align-top">
          <span
            class="btn-control-quantity"
            @click="sample.tqte > 1 ? vSetStoreSample('tqte', key, sample.tqte-1) : vDeleteLine(key)"
          >-</span>
        </div>
        <div class="form-field line-align-top">
          <div class="display-flex">
            <div class="form-field">
              <input
                type="checkbox"
                class="checkbox"
                :id="'top_gratuit_echantillon_'+key"
                :checked="getGrat"
                @change="vSetStoreSample('ttop_grat', key, $event.target.checked === true ? 1 : 0)"
              />
              <label :for="'top_gratuit_echantillon_'+key">{{$_('free')}}</label>
            </div>
          </div>
        </div>
        <div class="form-field line-align-top">
          <span class="trash-line" @click="vDeleteLine(key)">
            <img src="@/modules/produit/assets/img/trash.png" />
          </span>
        </div>
        <div class="amount-line">
          <div class="form-field">
            <small>{{$_('amount')}}: {{line_data[key].amount.line_pmontant}} {{line_data[key].amount.line_pcdev}}</small>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-add-list">
      <span @click="vAddSample">+ {{$_('add_sample')}}</span>
    </div>
  </div>
</template>

<script>

import productService from '@/modules/produit/services/productService';
import echantillonService from '@/modules/produit/services/echantillonService';

import Select from "@/common/components/widget/Select";
import Input from "@/common/components/widget/Input/Input";

export default {
  name: 'FormSample',
  data() {
    return {
      line_data: [],
      last_modified_index: 0,
      timeout_id: 0,
      reset: false
    }
  },
  components: {
    Select,
    Input
  },
  created() {
    if(this.getSample.length === 0) {
      this.vAddSample()
    }
  },
  computed: {
    getSample() {
      return this.$store.getters['echantillon/get_sample'];
    },
    getGrat() {
      return this.$store.getters['echantillon/get_ttop_grat'];
    },
    getElectro() {
      return this.$store.getters['echantillon/get_telectro'];
    }
  },
  watch: {
    getSample: {
      handler(sample) {

        if(

          sample[this.last_modified_index] !== undefined && (
          sample[this.last_modified_index].tmod !== '' &&
          sample[this.last_modified_index].topt !== '' &&
          sample[this.last_modified_index].ttail1 !== '' &&
          sample[this.last_modified_index].ttail2 !== '' &&
          sample[this.last_modified_index].tcol !== '' &&
          sample[this.last_modified_index].tmarq !== '')
        
        ) {

          productService.getPriceInfo({
            pmod: sample[this.last_modified_index].tmod,
            popt: sample[this.last_modified_index].topt,
            ptail1: sample[this.last_modified_index].ttail1,
            ptail2: sample[this.last_modified_index].ttail2,
            pcol: sample[this.last_modified_index].tcol,
            pmarq: sample[this.last_modified_index].tmarq,
            pqte: this.getSample[this.last_modified_index].tqte,
          }).then(res => {
            if (res.data !== undefined) {
              this.line_data[this.last_modified_index].amount = {
                line_pmontant: res.data.PMONTANT,
                line_pcdev: res.data.PCDEV
              };
            }
          });

          this.vGetProductInfo();
        }

        return sample
      },
      deep: true,
    }
  },
  methods: {
    vAddSample() {
      this.$store.dispatch('echantillon/SET_SAMPLE', {
        tmod: "",
        topt: "",
        ttail1: "",
        ttail2: "",
        tcol: 0,
        tmarq: "",
        tqte: 1,
        ttop_grat: this.getGrat,
        telectro: this.getElectro,
        tgenc: "",
        tds: "",
        tmailds: ""
      });

      this.last_modified_index = this.getSample.length - 1;

      this.line_data.push({
        packaging: Array(),
        size: Array(),
        color: Array(),
        amount: {
          line_pmontant: '',
          line_pcdev: '',
        }
      })
    },
    vSetStoreSample(key, line, value) {

      if(value.activate === 0) {
        this.reset = true;
        setTimeout(() => {
          this.reset = true
        })
        return false;
      }

      if(key === 'ttail') {
        if(value.item === '') {
          this.$store.dispatch('echantillon/SET_SAMPLE_LINE', {key: 'ttail1', line, value: ''})
          this.$store.dispatch('echantillon/SET_SAMPLE_LINE', {key: 'ttail2', line, value: ''})
        } else {
          let ttail = value.item.split('_');
          this.$store.dispatch('echantillon/SET_SAMPLE_LINE', {key: 'ttail1', line, value: ttail[0]})
          this.$store.dispatch('echantillon/SET_SAMPLE_LINE', {key: 'ttail2', line, value: ttail[1]})
        }
      } else if (key === 'tcol') {
        let tcol = value.item.split('#');
        this.$store.dispatch('echantillon/SET_SAMPLE_LINE', {key: 'tcol', line, value: tcol[0]})
        this.$store.dispatch('echantillon/SET_SAMPLE_LINE', {key: 'tmarq', line, value: tcol[1]})
      } else {

        if(value.item !== undefined) {
          value = value.item
        }

        this.$store.dispatch('echantillon/SET_SAMPLE_LINE', {key, line, value})
      }

      this.last_modified_index = line;

      setTimeout(() => {
        this.vGetProductInfo()
      }, 2000);
    },
    vDeleteLine(key) {
      this.$store.dispatch('echantillon/DELETE_SAMPLE_LINE', key);
      this.line_data.splice(key, 1);
    },
    vGetProductInfo() {

      clearTimeout(this.timeout_id);

      this.timeout_id = setTimeout(() => {

        if(this.getSample[this.last_modified_index] === undefined) return false

        return echantillonService.getInfoEchantillon({      
          fmod: this.getSample[this.last_modified_index].tmod !== '' ? this.getSample[this.last_modified_index].tmod : null,
          ftail1: this.getSample[this.last_modified_index].ttail1 !== '' ? this.getSample[this.last_modified_index].ttail1 : null,
          ftail2: this.getSample[this.last_modified_index].ttail2 !== '' ? this.getSample[this.last_modified_index].ttail2 : null,
          fopt: this.getSample[this.last_modified_index].topt !== '' ? this.getSample[this.last_modified_index].topt : null,
          fcol: this.getSample[this.last_modified_index].tcol !== '' ? this.getSample[this.last_modified_index].tcol : null,
          fmarq: this.getSample[this.last_modified_index].tmarq !== '' ? this.getSample[this.last_modified_index].tmarq : null,
        })
        .then(res => {

          // CONDITIONNEMENT
          if( res.data.DS_O3 !== undefined) {

            let topt_temp = Array();

            res.data.DS_O3.OUT.map(obj => {
              topt_temp.push({
                TOPT: obj.TOPT,
                TLIB_OPT: obj.TLIB_OPT,
                activate: obj.TOK3
              });
            });

            this.line_data[this.last_modified_index]['packaging'] = topt_temp;
          }
          // TAILLE
          if( res.data.DS_O4 !== undefined) {
            let ttail_temp = Array();

            res.data.DS_O4.OUT.map(obj => {
              ttail_temp.push({
                TTAIL: obj.TTAIL1+'_'+obj.TTAIL2,
                TLIB_TAIL: obj.TTAIL1+obj.TTAIL2,
                activate: obj.TOK4
              });
            });
            this.line_data[this.last_modified_index]['size'] = ttail_temp;
          }
          // COLORIS
          if( res.data.DS_O5 !== undefined) {

            let tcol_temp = Array();

            res.data.DS_O5.OUT.map(obj => {
              obj.id = obj.TCOL+'#'+obj.TMARQ;
              obj.libelle = obj.TCOL+' '+obj.TMARQ;
              obj.activate = obj.TOK5;
              tcol_temp.push(obj)
            });

            this.line_data[this.last_modified_index]['color'] = tcol_temp;
          }
        });
      }, 300);
    }
  }
};
</script>

<style scoped>
.sample-card-list {
  background-color: #f5f5f5;
  padding: 20px;
}
.form-field {
  padding: 0px 10px;
  display: flex;
  margin-bottom: 0px;
}
.sample-card-list {
  margin-top: 30px;
}
.sample-line {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.box-qte {
  min-width: 50px;
  max-width: 50px; 
}
/deep/
.box-qte input {
  min-width: 50px !important;
  max-width: 50px;
}
.trash-line {
  border: solid 1px #61424d;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.trash-line:hover {
  cursor: pointer;
}
.trash-line img {
  width: 20px;
}
.checkbox-container {
  display: flex;
}
.amount-line {
  display: flex;
  flex-basis: 100%;
  padding-left: 30px;
  margin: 10px 0px 20px;
}
.amount-line small {
  font-family: 'Lato-Regular';
  font-size: var(--fz-sm);
}
/deep/
.input-mod input {
  min-width: 50px;
  max-width: 100px;
}
.btn-control-quantity:hover {
  cursor: pointer
}
@media screen and (max-width: 800px) {
  /deep/
  .input-mod input {
    width: 100%;
    max-width: 100%;
  }
    .trash-line {
    margin: 15px auto;
  }
  .line-amount {
    padding: 0px
  }
  .btn-control-quantity {
    text-align: center;
    font-size: 1.3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border: solid 1px #b8b8b8;
    width: 35px;
    height: 35px;
    border-radius: 50%;
    margin: 10px auto;
  }
  .box-qte {
    width: 100%;
    max-width: 100%;
  }
  .sample-line:not(:last-child) {
    border-bottom: solid 1px #bfbfbf;
    margin-bottom: 20px;
  }
  /deep/
  .box-qte input {
    width: 100%;
    max-width: 100%;
  }
}
</style>